import { IActivityBase } from '../../models/activities';
import { ISpotBase } from '../../models/spots';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateSpotProps {
  spotId: string;
  description?: string;
  isActive: boolean;
  isLivingArea: boolean;
  name: string;
  ventureId: string;
}

export interface IUpdatedSpot extends ISpotBase {
  activities: IActivityBase[];
}

export const updateSpotsService = async ({
  spotId,
  description,
  isActive,
  isLivingArea,
  name,
  ventureId,
}: IUpdateSpotProps): Promise<IUpdatedSpot> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedSpot>(`/spots/${spotId}`, {
    description,
    isActive,
    isLivingArea,
    name,
    ventureId,
  });

  return data;
};
